module.exports = __webpack_public_path__ + "img/cl.d44611bc.png";